import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { MessagingEvents } from '../constants';
import { dispatchMessage } from '../messageDispatchers';

export const usePageLoadMessaging = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    dispatchMessage<string>({ event: MessagingEvents.EPageEvents.REDIRECT_EVENT, payload: pathname });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
